import { render } from "./Rating.vue?vue&type=template&id=8a888502&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"

import "./Rating.vue?vue&type=style&index=0&id=8a888502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a888502"]])

export default __exports__